// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum LowGrainShutOffMode {
    Auto = 1,
    TimedBypass = 2,
    Bypass = 3,
}
export default LowGrainShutOffMode;
